module.exports = __webpack_public_path__ + "img/4.d2fdb21e.webp";